import { useQuery } from '@tanstack/react-query';

import { useUserDetails } from '@/features/_shared/user';
import type { FeedFilters } from '@/features/markets/components/Feed/api/fetchFeedData';
import { fetchFeedData } from '@/features/markets/components/Feed/api/fetchFeedData';
import { feedKeys } from '@/features/markets/components/Feed/queries/feed.keys';

export const useFeedData = (metadata: FeedFilters) => {
  const { isUserExpired } = useUserDetails();

  return useQuery({
    queryKey: feedKeys.data(metadata),
    queryFn: () => fetchFeedData(metadata),
    refetchInterval: 10000,
    enabled: !isUserExpired
  });
};
